// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"362": "__federation_expose_App","365": "__federation_expose_Insurance","503": "__federation_expose_Receivable",}[chunkId] || chunkId) + "." + {"362": "8a28cf54","365": "f428acb0","396": "e7ed9c3b","499": "042be707","503": "889f6c45","531": "4051aefb","75": "42123591","912": "8c3a3ab1",}[chunkId] + ".js"
}